import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { tokenStorage } from '../services/api';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

export function useSocket() {
  return useContext(SocketContext);
}

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    const token = tokenStorage.get() || localStorage.getItem('token');

    if (!token || !user) {
      if (socket) {
        socket.close();
        setSocket(null);
      }
      return;
    }

    const socketUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    const newSocket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      auth: {
        token
      }
    });

    newSocket.on('connect', () => {
      console.log('✓ WebSocket connected as operator/dashboard');
      newSocket.emit('join_operator_room');
    });

    newSocket.on('connect_error', (err) => {
      console.warn('WebSocket connect error:', err.message);
    });

    newSocket.on('disconnect', (reason) => {
      console.log('WebSocket disconnected:', reason);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [user]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}

